import React, { Component } from "react";
import { string, bool, func, arrayOf, object, number } from "prop-types";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend
} from "recharts";
import withTheme from "../styles/withTheme";

export class TVBarChart extends Component {
  static propTypes = {
    theme: object.isRequired,
    data: arrayOf(object).isRequired,
    stackId: object,
    formatter: func,
    yAxisFormatter: func,
    primeKey: string,
    hasTooltip: bool,
    hasLegend: bool,
    normalized: bool,
    height: number,
    barGap: number
  };
  static defaultProps = {
    stackId: {},
    formatter: d => d,
    yAxisFormatter: d => d,
    primeKey: "name",
    hasTooltip: true,
    hasLegend: true,
    normalized: false,
    height: 300,
    barGap: 4
  };
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      width: 0
    };
  }
  handleResize = () => {
    setTimeout(() => {
      this.setState({
        width: document.getElementById("bar-chart-container").offsetWidth
      });
    }, 0);
  };
  componentDidMount() {
    this.initState();
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }
  initState() {
    let data;
    if (this.props.normalized) {
      data = this.props.data.map(datum => {
        const sum = Object.keys(datum)
          .filter(key => key !== this.props.primeKey)
          .reduce((pre, cur) => pre + datum[cur], 0);
        return {
          [this.props.primeKey]: datum[this.props.primeKey],
          uv: datum.uv / sum,
          pv: datum.pv / sum,
          amt: datum.amt / sum
        };
      });
    } else {
      data = this.props.data;
    }
    this.setState({
      data
    });
  }
  render() {
    const {
      theme,
      primeKey,
      formatter,
      yAxisFormatter,
      hasTooltip,
      hasLegend,
      stackId,
      height,
      barGap
    } = this.props;
    const {
      data,
      width,
    } = this.state;
    const sectorColor = theme.color.sector;
    if (data.length === 0) return null;

    const isLongData = data.length > 7;
    return (
      <div id="bar-chart-container">
        <BarChart
          width={width}
          height={height}
          data={data}
          barGap={barGap}
          margin={{ top: 20, right: 30, left: 0, bottom: 5 }}
        >
          <XAxis
            interval={ 0 }
            dataKey={primeKey}
            angle={ isLongData ? -45 : 0 }
            {
              ...(isLongData ? { textAnchor: 'end' } : {})
            }
          />
          <YAxis tickFormatter={yAxisFormatter} />
          <CartesianGrid strokeDasharray="3 3" />
          {hasTooltip && <Tooltip formatter={formatter} />}
          {
            hasLegend && <Legend
              wrapperStyle={{
                paddingTop: isLongData ? 50 : 0
              }}
            />
          }
          {Object.keys(data[0])
            .filter(key => key !== primeKey)
            .map((key, idx) => (
              <Bar
                key={key}
                dataKey={key}
                fill={sectorColor[Object.keys(sectorColor)[idx]]}
                stackId={stackId[key] ? stackId[key] : null}
              />
            ))}
        </BarChart>
      </div>
    );
  }
}

export function mapThemeToProps(theme) {
  return { theme };
}

export default withTheme(mapThemeToProps)(TVBarChart);



// WEBPACK FOOTER //
// ./src/legacy-tv-ui/BarChart/BarChart.js